module.exports = __webpack_public_path__ + "img/shopping-cart.e99e9579.svg";